import React, { useState } from 'react';
import axios from 'axios';
import { Form, Button, Container, Card, Alert, Image, InputGroup } from 'react-bootstrap';
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";


function RegisterForm() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isVerifying, setIsVerifying] = useState(false);
  const [showPassword, setShowPassword] = useState(false);


  const handleRegister = async (e) => {
    e.preventDefault();
    const userType = "customer";
    const formattedUsername = username.toLowerCase(); // Convert email to lowercase

    try {
      await Auth.signUp({
        username: formattedUsername,
        password,
        attributes: {
          email: formattedUsername,
        },
      });
      await axios.post(
        'https://vffutpswql.execute-api.us-east-1.amazonaws.com/dev/assign-group',
        { username: formattedUsername, userType }
      );
      setSuccess('Account created successfully! A verification code has been sent to your email.');
      setError('');
      setIsVerifying(true);
    } catch (error) {
      console.error('Registration error:', error);
      if (error.code === 'UsernameExistsException') {
        try {
          await Auth.resendSignUp(formattedUsername);
          setSuccess('A new verification code has been sent to your email.');
          setError('');
          setIsVerifying(true);
        } catch (resendError) {
          console.error('Resend verification error:', resendError);
          setError(resendError.message || 'An error occurred while resending the verification code.');
          setSuccess('');
        }
      } else {
        setError(error.message || 'An error occurred during registration.');
        setSuccess('');
      }
    }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    const formattedUsername = username.toLowerCase(); // Ensure lowercase before verification

    try {
      await Auth.confirmSignUp(formattedUsername, verificationCode);
      setSuccess('Verification successful, redirecting you to the login page now.');
      setError('');
      setTimeout(() => {
        window.location.href = '/login';
      }, 3000);
    } catch (error) {
      console.error('Verification error:', error);
      setError('Verification code entered incorrectly. Please try again.');
      setSuccess('');
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
      <Card style={{ maxWidth: "400px", width: "100%", borderRadius: "10px" }} className="shadow-sm p-4">
        <h3 className="text-center mb-4">
          {isVerifying ? "Verify Account" : "Create Customer Account"}
        </h3>

        <div className="d-flex justify-content-center mb-4">
          <Image
            src="/faithwelcome.png"
            alt="Welcome"
            fluid
            style={{ maxHeight: "200px", borderRadius: "8px" }}
          />
        </div>

        {error && <Alert variant="danger">{error}</Alert>}
        {success && <Alert variant="success">{success}</Alert>}

        {!isVerifying ? (
          <Form onSubmit={handleRegister}>
            <Form.Group className="mb-3">
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your email address"
                value={username}
                onChange={(e) => setUsername(e.target.value.toLowerCase())} // Convert as user types
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="password">
            <Form.Label>Password</Form.Label>
            <InputGroup>
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <InputGroup.Text
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  cursor: "pointer",
                  background: "white",
                  borderLeft: "none"
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </InputGroup.Text>
            </InputGroup>
          </Form.Group>





         
         

       

            <Button variant="primary" type="submit" className="w-100 rounded-pill btn-accent">
              Create Customer Account
            </Button>
            <div className="mt-2">
              Already have an account?{" "}
              <span
                style={{ color: "#0d6efd", cursor: "pointer" }}
                onClick={() => navigate("/login")}
              >
                Sign In
              </span>
            </div>
          </Form>
        ) : (
          <Form onSubmit={handleVerify}>
            <Alert variant="info">
              Please enter the verification code sent to your email.
            </Alert>
            <Form.Group className="mb-3">
              <Form.Label>Verification Code</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter verification code"
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit" className="w-100">
              Verify
            </Button>
          </Form>
        )}
      </Card>
    </Container>
  );
}

export default RegisterForm;
